import { render, staticRenderFns } from "./TextFieldArray.vue?vue&type=template&id=247a8e9e"
import script from "./TextFieldArray.vue?vue&type=script&lang=js"
export * from "./TextFieldArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports